export type Rules = Rule[];

export type AllowedPlatform = 'all' | 'mobile_pax' | 'web' | 'offline_sales';

export type Rule =
  | AllowedCountriesRule
  | AllowedPlatformsRule
  | BlackoutPeriodRule
  | DirectRideRule
  | LineBlacklistRule
  | LineWhitelistRule
  | MinimumTicketsAmountRule
  | MinimumValueRule
  | OfflineSalesRule
  | TravelPeriodRule
  | WeekdaysTravelRule
  | FreeAncillariesRule;

export interface AllowedCountriesRule {
  type: 'allowed_countries';
  countries: string[];
}

export interface AllowedPlatformsRule {
  type: 'allowed_platforms';
  platforms: AllowedPlatform[];
}

export interface BlackoutPeriodRule {
  type: 'blackout_period';
  start?: string; // ISO 8601 date string
  end?: string; // ISO 8601 date string
}

export interface DirectRideRule {
  type: 'direct_ride';
}

export interface LineBlacklistRule {
  type: 'line_blacklist';
  lines: string[]; // UUIDs (lineId)
}

export interface LineWhitelistRule {
  type: 'line_whitelist';
  lines: string[]; // UUIDs (lineId)
}

export interface MinimumTicketsAmountRule {
  type: 'minimum_tickets_amount';
  count: number;
}

export interface MinimumValueRule {
  type: 'minimum_value';
  value: {
    amount: number;
    currency: string;
  };
}

export interface OfflineSalesRule {
  type: 'offline_sales';
}

export interface TravelPeriodRule {
  type: 'travel_period';
  start?: string; // ISO 8601 date string
  end?: string; // ISO 8601 date string
}

export interface WeekdaysTravelRule {
  type: 'weekdays_travel';
  weekDays: string[]; // Days of the week, e.g., "Monday"
}

export interface FreeAncillariesRule {
  type: 'free_ancillaries';
  ancillaries: FREE_ANCILLARIES[];
}

export enum FREE_ANCILLARIES {
  //eslint-disable-next-line
  PLATFORM_FEE = 'platformFee',
  //eslint-disable-next-line
  SEAT_RESERVATION = 'seatReservation',
}

export const FreeAncillariesMap: Record<FREE_ANCILLARIES, string> = {
  platformFee: 'Platform Fee',
  seatReservation: 'Seat Reservation',
};

export const RulesMap: Record<Rule['type'], string> = {
  allowed_countries: 'Allowed Countries',
  allowed_platforms: 'Allowed Platforms',
  blackout_period: 'Blackout Period',
  direct_ride: 'Direct Ride',
  line_blacklist: 'Forbidden lines',
  line_whitelist: 'Allowed lines',
  minimum_tickets_amount: 'Minimum Tickets Amount',
  minimum_value: 'Minimum Value',
  offline_sales: 'Offline Sales',
  travel_period: 'Travel Period',
  weekdays_travel: 'Allowed Weekdays',
  free_ancillaries: 'Free Ancillaries',
};
